export const measureLabel = unit => ({ m2: 'm²', m3: 'm³', linear_m: 'm', pcs: 'pcs' }[unit] || unit || '—');
export const numberLabel = (value, language) => {
  const locale = ({ sq: 'sq-AL', mk: 'mk-MK' })[String(language).split(/[-_@]/)[0]] || 'en-GB';
  return value == null ? '—' : new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(value);
};
export const jobQuantity = (job, summary) => {
  if (!summary) return { quantity: job.area_m2 === '' || job.area_m2 == null ? null : Number(job.area_m2), unit: job.measurement_unit || 'm2', source: 'manual' };
  const primary = job.primary_subtask_id && summary.subtasks?.[job.primary_subtask_id];
  if (job.primary_subtask_id) return {
    quantity: primary?.units?.length === 1 ? primary.total : null,
    unit: primary?.units?.length === 1 ? primary.units[0] : null,
    issue: !primary ? 'missing_primary_quantity' : primary.units.length !== 1 ? 'mixed_units' : null,
    source: 'materials',
  };
  return { quantity: summary.auto_quantity, unit: summary.auto_unit, issue: summary.auto_issue, source: 'materials' };
};